import * as routerNames from '@/services/router/router.names'

import TicketPortalListing from '@/screens/ticket-portal/ticket-portal-listing.vue'
import TicketPortalDetail from '@/screens/ticket-portal/ticket-portal-detail.vue'
import TicketPortalProfile from '@/screens/ticket-portal/ticket-portal-profile.vue'

export default [
  {
    path: '/:accountId/ticket-portal/:mailboxId',
    name: routerNames.TICKET_PORTAL_LISTING,
    component: TicketPortalListing,
    meta: {
      accountMembershipAgnostic: true,
    },
  },
  {
    path: '/:accountId/ticket-portal/:mailboxId/ticket/:ticketId',
    name: routerNames.TICKET_PORTAL_DETAIL,
    component: TicketPortalDetail,
    meta: {
      accountMembershipAgnostic: true,
    },
  },
  {
    path: '/:accountId/ticket-portal/:mailboxId/profile',
    name: routerNames.TICKET_PORTAL_PROFILE,
    component: TicketPortalProfile,
    meta: {
      accountMembershipAgnostic: true,
    },
  },
]
